module.exports = __webpack_public_path__ + "static/media/4-foundations-value.02b10aa0.jpg";